import "./ConfessionsTable.css";
import * as React from "react";
import Popup from "reactjs-popup";
import Button from "@mui/material/Button";
import { Grid } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { styled } from "@mui/material/styles";
import ConfessionTextField from "./ConfessionTable/ConfessionTextField";
import NumberSwitch from "./ConfessionTable/NumberSwitch";
import EmailRounded from "@mui/icons-material/EmailRounded";
import { lightTheme } from "../themes/lightTheme";
import { darkTheme } from "../themes/darkTheme";
import { useState, useRef } from "react";
import ConfessionTableTitle from "./ConfessionTable/ConfessionTableTitle";
import { useFingerprint } from "../hooks/useFingerprint";
import "reactjs-popup/dist/index.css";

const ConfessionsTable = (props) => {
  const [confession, setConfession] = useState("");
  const [ID, setID] = useState("");
  const [isErr, setIsErr] = useState(false);
  const fingerprint = useFingerprint();
  const numberSwitchRef = useRef();
  const confessionTextRef = useRef();
  const formRef = useRef();

  // pop up
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeModal = () => {
    setIsModalOpen(false);
    setIsErr(false);
  };

  const onSaveConfessionText = (data) => {
    setConfession(data);
  };

  const onCommentToExistingConfession = (data) => {
    setID(data);
  };

  async function onSubmission() {
    if (confession.trim()) {
      numberSwitchRef.current.turnToggleOff();
      let confessionData = {
        text: confession,
        isComment: ID !== "",
        ID: ID,
        fingerprint: fingerprint,
      };
      const res = await fetch(
        process.env.NODE_ENV === "development"
          ? "http://localhost:8080/api/postConfession"
          : "api/postConfession",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(confessionData),
        },
      );
      if (res.ok) {
        numberSwitchRef.current.clear();
        confessionTextRef.current.clear();
        setID("");
        setConfession("");
      } else {
        setIsErr(true);
      }
      setIsModalOpen((o) => !o);
    }
  }

  let submitButtonBG, submitButtonHoverBG, submitTextHover, submitBorder;

  function renderTheme() {
    let root = document.documentElement;

    if (props.theme === "light") {
      root.style.setProperty("--confession-table-bg", lightTheme.confessionBG);
      root.style.setProperty(
        "--confession-table-border",
        lightTheme.confessionBorder,
      );
      root.style.setProperty(
        "--confession-table-title",
        lightTheme.confessionTitle,
      );
      submitButtonBG = lightTheme.submitButtonBG;
      submitButtonHoverBG = lightTheme.submitButtonHoverBG;
      // confessionTitle = lightTheme.confessionTitle;
      submitTextHover = lightTheme.submitTextHover;
      submitBorder = lightTheme.submitBorder;
    } else {
      root.style.setProperty("--confession-table-bg", darkTheme.confessionBG);
      root.style.setProperty(
        "--confession-table-border",
        darkTheme.confessionBorder,
      );
      root.style.setProperty(
        "--confession-table-title",
        darkTheme.confessionTitle,
      );
      submitButtonBG = darkTheme.submitButtonBG;
      submitButtonHoverBG = darkTheme.submitButtonHoverBG;
      // confessionTitle = darkTheme.confessionTitle;
      submitTextHover = darkTheme.submitTextHover;
      submitBorder = darkTheme.submitBorder;
    }
  }

  renderTheme();

  const ColorButton = styled(Button)(({ theme }) => ({
    color: submitTextHover,
    marginTop: "5px",
    boxShadow: "none",
    border: "1px solid " + submitBorder,
    borderRadius: "20px",
    backgroundColor: submitButtonBG,
    "&:hover": {
      backgroundColor: submitButtonHoverBG,
      color: submitTextHover,
      boxShadow: "none",
    },
  }));

  const recaptchaRef = React.createRef();

  return (
    <form
      ref={formRef}
      onSubmit={() => {
        recaptchaRef.current.execute();
      }}
    >
      <div className="content-table">
        <Grid container spacing={2}>
          <ConfessionTableTitle
            theme={props.theme}
            title="Send a Confession"
            icon={<EmailRounded />}
          />
          <ConfessionTextField
            theme={props.theme}
            onSaveConfessionText={(data) => {
              onSaveConfessionText(data);
            }}
            ref={confessionTextRef}
          />
          <NumberSwitch
            theme={props.theme}
            onCommentToExistingConfession={onCommentToExistingConfession}
            ref={numberSwitchRef}
          />
          <Grid
            container
            direction="column"
            alignItems="flex-end"
            justify="flex-end"
          >
            <ColorButton
              variant="contained"
              onClick={() => {
                if (formRef.current.reportValidity()) {
                  onSubmission();
                }
              }}
              endIcon={<SendIcon />}
            >
              Send
            </ColorButton>
            <Popup open={isModalOpen} closeOnDocumentClick onClose={closeModal}>
              <div className="modal">
                <div role="button" className="close" onClick={closeModal}>
                  &times;
                </div>
                <div className="header">
                  {isErr ? "Error ❌" : "All done ✅"}
                </div>
                <div className="content">
                  {isErr
                    ? "Unable to submit your confession. You may have reached your submission limit. Try again later, or contact the page via Facebook if it seems like an error."
                    : "You spilled the tea! Thanks for the confession!"}
                </div>
              </div>
            </Popup>
          </Grid>
        </Grid>
      </div>
    </form>
  );
};

export default ConfessionsTable;
